module.exports = __webpack_public_path__ + "static/media/ES.a62a83f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/ES.svg
// module id = 2148
// module chunks = 7